<template>
  <div
    class="payment-list-item d-flex flex-grow-1 justify-space-between align-center px-6 py-4"
  >
    <div class="" :style="{ width: '100%' }">
      <div
        :style="{
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center'
        }"
      >
        <div>
          <div v-if="item.paymentAccountId === null">
            <div class="payment-item__title flex-1">
              {{ $t("payments.no_online_payment_title") }}
            </div>
          </div>
          <div v-else>
            <img
              v-if="renderPaymentProviderLogo"
              :src="renderPaymentProviderLogo"
              alt="Payment provider logo"
              class="payment-item__logo"
            />
          </div>
        </div>

        <span v-if="isAdminScreen">
          <v-switch
            :style="{ paddingTop: 0, marginTop: 0 }"
            v-if="showActiveToggle"
            :input-value="item.active"
            :loading="activeLoading === item.paymentAccountId"
            dense
            hide-details
            label="Active"
            x-small
            @click="toggleActive"
          />
        </span>
      </div>
      <div
        :style="{
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center'
        }"
      >
        <div class="payment-item__subtitle" style="margin-top: 0px;">
          {{ item.emailAddress }}
        </div>

        <div v-if="isAdminScreen" class="d-flex flex-end flex-row text-right ">
          <a href="#" style="margin-top: 5px;" @click="toggleEdit">Edit</a>
        </div>
      </div>
    </div>

    <EditPaymentModal
      :is-add-payment-modal-open="editOpen"
      :item="item"
      :payments-accounts-change="updateFees"
      :toggle-modal="toggleEdit"
    />
    <CommonButton
      v-if="showSelect"
      :color="renderSelectButtonColor"
      :customClassName="renderSelectButtonClassName"
      :label="renderSelectButtonLabel"
      width="100"
      @handleClick="toggleSelectPaymentProcessor"
    />
  </div>
</template>

<script>
import CommonButton from "../academy/common/CommonButton";
import { i18n } from "../../plugins/i18n";
import payPalLogo from "../../assets/images/PP_logo_h_150x38.png";
import stripeLogo from "../../assets/images/Stripe wordmark - blurple (small).png";
import fluidpayLogo from "../../assets/images/fluidpay-logo.png";
import { PaymentProvidersTypes } from "../academy/enums/PaymentProvidersTypes";
import { Routes } from "@/router/Routes";
import EditPaymentModal from "./EditPaymentModal";

export default {
  name: "NewFeePaymentListItem",
  components: { EditPaymentModal, CommonButton },
  props: {
    showSelect: {
      type: Boolean,
      required: false,
      default: true
    },
    item: {
      type: Object,
      required: true
    },
    selectPayment: {
      type: Function,
      required: false
    },
    isSelectedPayment: {
      type: Boolean,
      required: false
    },
    activeLoading: {
      type: String
    },
    showActiveToggle: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      percent: null,
      cents: null,
      showPercent: false,
      showCents: false,
      editOpen: false
    };
  },
  mounted() {
    this.percent = (this.item.processingFeePerMilli / 10).toFixed(1);
    this.cents = (this.item.processingFeeInCents / 100).toFixed(2);
  },
  computed: {
    isAdminScreen() {
      return this.$route.name === Routes.COACH_TEAMS.name;
    },
    percentDifference() {
      return this.percent !== (this.item.processingFeePerMilli / 10).toFixed(1);
    },
    centsDifference() {
      return this.cents !== (this.item.processingFeeInCents / 100).toFixed(2);
    },
    renderSelectButtonLabel() {
      return this.isSelectedPayment
        ? i18n.tc("payments.selected")
        : `+ ${i18n.tc("payments.select")}`;
    },

    renderSelectButtonColor() {
      return this.isSelectedPayment ? "secondary" : "transparent";
    },

    renderSelectButtonClassName() {
      let className = "";
      if (this.isSelectedPayment) {
        className = "";
      } else {
        className = "add_button";
      }
      return `${className} font-weight-medium`;
    },
    renderPaymentProviderLogo() {
      const { PAYPAL, STRIPE, FLUIDPAY } = PaymentProvidersTypes;
      if (this.item.paymentProviderName === PAYPAL) {
        return payPalLogo;
      } else if (this.item.paymentProviderName === STRIPE) {
        return stripeLogo;
      } else if (this.item.paymentProviderName === FLUIDPAY) {
        return fluidpayLogo;
      }
      return null;
    }
  },
  methods: {
    toggleEdit() {
      this.editOpen = !this.editOpen;
    },
    focusPercent() {
      this.showPercent = true;
      setTimeout(() => {
        this.$refs[`${this.item.paymentAccountId}-percent`].focus();
      }, 10);
    },
    focusCents() {
      this.showCents = true;
      setTimeout(() => {
        this.$refs[`${this.item.paymentAccountId}-cents`].focus();
      }, 10);
    },
    updateFees({ percent, amount }) {
      const newAccount = { ...this.item };
      this.item.processingFeePerMilli = percent * 10;
      newAccount.processingFeePerMilli = percent * 10;
      this.item.processingFeeInCents = amount * 100;
      newAccount.processingFeeInCents = amount * 100;
      this.showCents = false;
      this.showPercent = false;
      this.$emit("updateFees", newAccount);
    },
    toggleActive() {
      this.$emit("toggleActive");
    },
    toggleSelectPaymentProcessor() {
      this.selectPayment && this.selectPayment();
    }
  }
};
</script>

<style scoped>
.payment-list-item:not(:first-child) {
  border-top: 1px solid var(--divider-color);
}

.fee-editable-input {
  margin-right: 4px;
  background-color: #edeaeae5;
  border-radius: 4px;
  padding: 0 5px;
  cursor: pointer;
  margin-left: 2px;
  width: 50px;
  height: 18px;
  text-align: right;
  transition: 0.2s;
}

.fee-editable {
  background-color: #edeaeae5;
  border-radius: 4px;
  padding: 0 5px;
  cursor: pointer;
  margin-right: 2px;
  margin-left: 2px;
  width: 50px;
  height: 18px;
  text-align: right;
  transition: 0.2s;
}

.fee-editable:hover {
  background-color: #cfcecee5;
  transition: 0.2s;
}

.add_button {
  border: 1px solid var(--primary-color--dark) !important;
}
.payment-item__logo {
  width: 80px;
}
.payment-item__title {
  font-size: 16px;
  color: var(--dark-color);
  font-weight: var(--font-weight-medium);
}
.payment-item__subtitle {
  font-size: 14px;
  color: var(--dark-color);
  font-weight: var(--font-weight-regular);
}
.edit-underline {
  text-decoration: underline;
  color: blue;
  font-size: 12px;
  margin-top: 3px;
}
</style>
